
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Jugalbandi </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm jugalbandi section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Jugal<span >Bandi</span></h2>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">GANDHAR DESHPANDE <span class="small-sm">01<sup>st</sup> May 2019 </span></h2>
                </div>
                <p>
                    Born in Bhandara, Maharashtra now settled in Mumbai, 22 year old Gandhar Deshpande is a powerhouse
                    of talent. He commenced his musical training at the age of five. His first gurus were his parents,
                    Pandit Dr. Ram Deshpande and, Smt. Archana Deshpande, both vocalists and experts in Hindustani
                    music; he is further honing his skills under the guidance of Pt. Ram Deshpande for Gwalior, Jaipur,
                    and Agra Gharana gayaki by ‘Gurushishya Parampara’, from past 13 years.
                </p>
                <p>
                    Gandhar has won many accolades in various music competitions and has bagged eight gold medals in
                    last six years and two at ‘National Youth Festival’ consistently for 2 years. Gandhar is also a
                    recipient of the Hridayesh Award (2013) and the Pandit Vishnu Digambar Paluskar Award (2008).
                </p>
                <p>
                    In 2017 Gandhar collaborated with ‘Justin Tracy’ American Western Musician for ‘Mumbai Night’ album
                    which was selected as an entrant for prestigious Grammy Awards.
                </p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_7.webp"
                        alt="GHRSCF">
                </div>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row flex-row-reverse" id="prasad-khaparde">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">Aditya Modak <span class="small-sm">01<sup>st</sup> May 2019 </span></h2>
                </div>
                <p>
                    A child prodigy, started learning Indian Classical Music at an early age of five years from Shri.
                    Chandrakant Parker and Shri. Pradip Dhond. Presently, he is seeking training under the able guidance
                    of a renowned artist of Gwalior Gharana, Dr. Ram Deshpande for the last seven years.
                </p>
                <p>
                    Recently, Aditya was awarded the First Prize at the University National level organized at Tirupati.
                    He has also received the Chaturang Foundation Award for Hindustani Classical Music for the Year 2011
                    awarded by the Chaturang Foundation.
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_8.webp"
                        alt="GHRSCF">
                </div>
            </div>
            <div class="col-md-12 mt-3">
                <p>
                    Aditya has presented his art across the country as well as outside India in his concerts held at New
                    York, Indiana, Long Island and many others prestigious places.
                </p>
                <p>
                    Aditya is one of the main teachers at www.kutir.com and also on other Online Teaching platforms.
                </p>
                <p>
                    Aditya has completed his Visharad Purna as well as <b>Sangeet Alankar from the Gandharva
                        Mahavidyalaya, Miraj with "Excellence"</b> . Aditya also has many scholarships to his account. A
                    select few would be : The National Scholarship awarded by the Central Government of India; The Sawai
                    Gandharva Scholarship awarded by the Sawai Gandharva Association, Pune; The Bhimsen Joshi
                    Scholarship awarded by the University of Mumbai and many others.
                </p>
                <p>
                    On the academic front, Aditya has completed his graduation in commerce and he has completed
                    <b>Chartered Accountancy Course in first attempt</b> .
                </p>
            </div>
            <div class=" text-justify">
                <h2 class="head-lea">Invitation</h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/invitation_gd_am.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/invitation_gd_am.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/invitation_gd_am.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>

        </div>

        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                </div>
                <iframe src="https://drive.google.com/file/d/1SE1XF0FhZW0nTSRT2Ldnr00XdtyCsQlJ/preview" width="100%"
                    height="230" frameborder="0" allowfullscreen="true"></iframe>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                    <iframe width="100%" height="250" src="https://www.youtube.com/embed/4hLcioiV8JU" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>

                </div>


            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery#deviki-pandit" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/j_6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>
        </div>
    </div>

</section>
